import React from 'react';
import withLoading from '../components/withLoading';
import sizeMe from 'react-sizeme';
import Flexbox from 'flexbox-react';
import { Button, Glyphicon, Dropdown, MenuItem } from 'react-bootstrap';
import CustomToggle from '../components/CustomToggle';

function withResize(WrappedComponent) {
  return class extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        isResize: true,
      };
    }

    componentWillReceiveProps(nextProps) {
      this.setState({ isResize: !(this.props.size.width === nextProps.size.width && this.props.size.height === nextProps.size.height) });
    }

    render() {
      return (
        <WrappedComponent isResize={this.state.isResize} width={this.props.size.width} height={this.props.size.height} {...this.props} />
      )
    }
  };
}

function withTitle(WrappedComponent) {
  const SuperComponent = sizeMe({ monitorHeight: true })(WrappedComponent)

  return props => (
    <Flexbox flexDirection="column" className="chart">
      <Flexbox className="title" flexDirection="row" justifyContent="space-between" flexShrink={0}>
        <h2>{props.title}</h2>
        <div>
          {props.onMaximized &&
            <Button bsStyle="link" onClick={props.onMaximized} style={{ outline: 'none' }}>
              <Glyphicon glyph="resize-full" style={{ color: '#666a73' }} />
            </Button>
          }
          {props.displayOptions &&
            <Dropdown id="dropdown-custom-1" pullRight>
              <CustomToggle bsRole="toggle">
                <Glyphicon glyph="option-vertical" style={{ color: '#666a73' }} />
              </CustomToggle>
              <Dropdown.Menu>
                <MenuItem header>Display</MenuItem>
                {props.displayOptions.map(option => (
                  <MenuItem active={option === props.selectedDisplayOption} onSelect={(eventKey) => props.onViewSelected(eventKey)} key={option} eventKey={option}>
                    <span style={{ display: 'inline-block', width: '20px' }}>{props.selectedDisplayOption === option ? '✓' : null}</span>
                    {option}
                  </MenuItem>
                ))}
              </Dropdown.Menu>
            </Dropdown>
          }
          {props.onMinimized &&
            <Button bsStyle="link" onClick={props.onMinimized} style={{ outline: 'none' }}>
              <Glyphicon glyph="remove" style={{ color: '#666a73' }} />
            </Button>
          }
        </div>
      </Flexbox>
      <Flexbox flexGrow={1}>
        <SuperComponent {...props} />
      </Flexbox>
    </Flexbox>
  )
}

export default function (WrappedComponent) {
  return withLoading(withTitle(withResize(WrappedComponent)));
}



// WEBPACK FOOTER //
// ./src/components/withTitle.js